const isProduction = process.env.NODE_ENV === 'production'

export const agreementMap = new Map([
  [
    'userAgreement',
    {
      text: '《用户服务协议》',
      url: '/agreement.html',
    },
  ],
  [
    'privateAgreement',
    {
      text: '《隐私政策》',
      url: '/private-history',
    },
  ],
  [
    'thirdPartyAgreement',
    {
      text: '《第三方信息共享清单》',
      url: '/third-party-agreement.htm',
    },
  ],
  [
    'personalInfoAgreement',
    {
      text: '《个人信息收集清单》',
      url: '/personal-info-agreement.htm',
    },
  ],
  [
    'esignAgreement',
    {
      text: '《e签宝服务协议》',
      url: '/esign-agreement.htm',
    },
  ],
  [
    'esignPrivateAgreement',
    {
      text: '《e签宝隐私协议》',
      url: '/esign-private.htm',
    },
  ],
])
